// UssdPayment.js
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

function UssdPayment() {
  // USSD payment UI elements and logic
  return (
    <>
      <div className="py-2 d-flex justify-content-center">
        <h2 className="text-center py-2">USSD</h2>
        <p>Coming soon...</p>
      </div>
    </>
  );
}

export default UssdPayment;
